<template>
  <div class="page-container">
    <div class="query-title">销售计划汇总查询报表</div>

    <div class="content">
      <QueryParams v-if="searchReady" ref="QueryParams" limitSearchLength="4" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel2" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="left"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
            @cell-dblclick="cellClick"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { apiSalePlansumserch } from '@/api/sap/sale-plan'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from '../config/salePlanCountList'
import { frontExport, concurrencyReq, sapDownloadFile } from '@/utils/frontExport'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false,
      postingDate: '',
      searchReady: false,
    }
  },
  created() {
    this.postingDate = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
    this.initDefQueryPlanType()
  },
  methods: {
    async initDefQueryPlanType() {
      try {
        const formData = new FormData()
        formData.append('code', 'defQuery_planType')
        const res = await apiLoadDictionaryDtl(formData)
        const rows = res?.data?.Rows || []
        const values = rows.map(v => v.value).filter(Boolean)
        if (values.length) {
          pageSearch.plan_type.defaultVal = values
          this.initPage(pageConfig)
        }
        this.searchReady = true
      } catch (e) {}
    },
    showApply(row) {
      this.$router.push({
        path: '/wly/contract/edit',
        query: {
          id: row.cntrno
        }
      })
    },
    cellClick({ row }) {
      this.$emit('change-action', 'detail', row)
    },
    filterChannel(channel) {
      return channel.map(v => v.chl_name).join(',')
    },
    filterChfl(channel) {
      return channel.map(v => v.value_kt).join(',')
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        sort: this.sortData.concat(this.tableSort)
      }
      // 如果点击查询，传入标识符，后端返回 过滤条件 和 计算数据
      params.is_result = 1
      this.loading = true
      try {
        const { data, total, calculation, field } = await apiSalePlansumserch(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 导出全部 导出本页
    async exportExcel2() {
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_download: 'X',
        sort: this.sortData.concat(this.tableSort)
      }
      const { file } = await apiSalePlansumserch(params)
      this.fileData = file

      sapDownloadFile(this.fileData, '销售计划汇总'+ this.postingDate +'.xlsx')
    },
    async exportExcel() {
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiSalePlansumserch)
      frontExport(this.gridOptions.columns, data, '销售计划汇总')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/salePlanCountList.vue